import { schema } from 'normalizr'

const tableBill = new schema.Entity('tableBills')

export default tableBill
